import { useMutation } from "@tanstack/react-query";

import { confirmMfaSetupRequest } from "../requests/confirm-mfa-setup-request";

export const useConfirmMfaSetupMutation = () => {
  return useMutation({
    mutationFn: confirmMfaSetupRequest,
  });
};
